import { PriorityFeedCapabilityConfiguration } from './configuration';
import { PriorityFeedRoutes } from './routes';

angular
  .module('capability-ng-priority-feed', [
    'capability-ng-study-groups',
    'capability-ng-course-schedule',
    'capability-ng-holds',
    'capability-ng-conversations',
    'capability-ng-todos',
    'data-ng-personal-reminders',
    'capability-ng-survey',
    'ngAria',
    'ui.router'
  ])
  .service('ngPriorityFeedCapabilityConfiguration', PriorityFeedCapabilityConfiguration)
  .config(PriorityFeedRoutes);

import './core';

export * from './configuration';
export * from './models/knowledge_bot_model';
export * from './models/pronouns_model';
export * from './models/stcconfigs_model';
export * from './models/self_alert_term_model';
export * from './queries/knowledge_bot_query';
export * from './queries/pronouns_query';
export * from './queries/sum_badge_count_query';
export * from './queries/openable_elements_query';
export * from './queries/self_alert_icon_details_query';

export const PROIORITY_FEED = 'capability-ng-priority-feed';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/main.ts